import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

/* ICONS */
import { MdContactSupport, MdMedicalServices } from "react-icons/md";
import { RiRefreshLine, RiArrowLeftRightLine } from "react-icons/ri";
import { TbRepeat } from "react-icons/tb";

/* API IMPORT */
import { getDashboardCounts } from "../../service/api";

const Dashboard = () => {
  // STATE VARIABLES
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState(null);

  /* USE-EFFECTS */
  useEffect(() => {
    getDashboardCounts()
      .then((res) => {
        if (res?.status) {
          setCounts(res?.data);
        }
      })
      .catch((e) => {
        console.log("Error: ", e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const tiles = [
    {
      id: 1,
      label: "Contact Requests",
      value: counts?.contact,
      link: "/contact-requests",
      icon: MdContactSupport,
    },
    {
      id: 2,
      label: "Refill Requests",
      value: counts?.refill,
      link: "/refill-requests",
      icon: RiRefreshLine,
    },
    {
      id: 3,
      label: "Transfer Requests",
      value: counts?.transfer,
      link: "/transfer-requests",
      icon: RiArrowLeftRightLine,
    },
    {
      id: 4,
      label: "Auto Rx Enrollments",
      value: counts?.autoRefill,
      link: "/auto-rx-requests",
      icon: TbRepeat,
    },
    {
      id: 5,
      label: "Website Services",
      value: counts?.services,
      link: "/services",
      icon: MdMedicalServices,
    },
  ];

  return (
    <section className="px-0 py-2 xl:p-5 lg:p-5">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Dashboard | WellCare Pharmacy</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div>
          <h1 className="text-2xl font-ibm-bold text-black tracking-tight">
            Dashboard
          </h1>
          <h2 className="text-base xl:text-lg lg:text-lg font-ibm-regular text-greyText tracking-tight">
            A quick overview of the requests received from your website.
          </h2>
        </div>

        {/* COUNT TILES */}
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 lg:grid-cols-5 gap-5">
          {tiles.map((tile) => (
            <Link to={tile.link} key={tile.id}>
              <div className="bg-white rounded-lg border border-authBorder p-5 hover:border-black transition-all duration-300 ease-in-out">
                <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center">
                  <tile.icon className="w-5 h-5 text-white" />
                </div>
                <p className="mt-4 text-3xl font-ibm-bold text-black">
                  {loading ? "—" : tile.value ?? 0}
                </p>
                <p className="mt-1 text-sm font-ibm-regular text-greyText">
                  {tile.label}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
